import { useSuspenseQuery } from '@tanstack/react-query'
import axios from 'axios'
import z from 'zod'

async function getProfileFields() {
  const response = await axios.get('/api/profile_fields')
  return z.array(ProfileFieldSchema).parse(response.data)
}

export function useProfileFields() {
  return useSuspenseQuery({
    queryKey: ['profile_fields'],
    queryFn: getProfileFields,
  })
}

export const ProfileFieldSchema = z.object({
  profile_field_id: z.number(),
  name: z.string(),
  key: z.string(),
  order: z.number(),
  kind: z.enum(['text', 'number', 'date', 'boolean', 'country', 'select']),
  choices: z.array(z.string()),
  is_required: z.boolean(),
})

export type ProfileField = z.infer<typeof ProfileFieldSchema>
